import { DialogContent, DialogTitle } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { BoundTextField } from "lib/@components/binding/bound-components"

export function CopDocumentAddUrlDialog() {
    return (
        <DataInputDialog
            initialValue={{ name: "", url: "" }}
            okLabel="Add"
            okCaption="Add URL Document"
            okDisabled={isInvalid}
        >
            <DialogTitle>Add URL Document</DialogTitle>
            <DialogContent>
                <BoundTextField
                    field="name"
                    label="Document Name"
                    fullWidth
                    sx={{ mt: 1, mb: 2 }}
                    yup="string.trim.required"
                    autoFocus
                />
                <BoundTextField
                    field="url"
                    label="URL"
                    fullWidth
                    placeholder="https://..."
                    yup="string.trim.required"
                />
            </DialogContent>
        </DataInputDialog>
    )
}

function isInvalid(value) {
    return !value?.name?.trim() || !value?.url?.trim()
}
